import { checkoutOptimizationStepArraySchema } from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import * as z from "zod";

const checkoutTreeFlowStepNoSplitSchema = z.object({
  hasActiveSplit: z.literal(false),
  steps: checkoutOptimizationStepArraySchema,
});

const checkoutTreeFlowStepWithSplitSchema = z.object({
  hasActiveSplit: z.literal(true),
  steps: checkoutOptimizationStepArraySchema,
  concludedSteps: checkoutOptimizationStepArraySchema.optional(),
});

const checkoutTreeFlowStepSchema = z.discriminatedUnion("hasActiveSplit", [
  checkoutTreeFlowStepNoSplitSchema,
  checkoutTreeFlowStepWithSplitSchema,
]);

export const getCheckoutTreeFlowSteps = {
  name: "getCheckoutTreeFlowSteps" as const,
  input: z.null(),
  output: checkoutTreeFlowStepSchema,
};
export type GetCheckoutTreeFlowStepsOutput = z.infer<
  typeof getCheckoutTreeFlowSteps.output
>;
